import React, { useEffect, useState } from "react";
import MaskedInput from "react-text-mask";

export const CKYCUploadFileWithName = (props) => {
    const [getDocID, setGetDocID] = useState("");

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    useEffect(() => {
        if (props.DocumentTypeID) {
            const cleanedID = props.DocumentTypeID.replace(/\s/g, "").toUpperCase();
            console.log(cleanedID, "cleanedID")
            setGetDocID(cleanedID);
        }
    }, [props.DocumentTypeID]); // Runs only when DocumentTypeID changes

    console.log(getDocID, "getDocID (from props.DocumentTypeID)");
    console.log((props.DocumentIDValue), "DocumentIDValue");

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <p>Proof of {props.title} ({props.title === "Identity" ? "POI" : "POA"})</p>
                </div>
                <div className="col-md-4">
                    <select
                        className="packageForm"
                        value={props.DocumentTypeID}
                        onChange={(e) => {
                            props.setDocumentType(e.target.value);     // update selected document type
                            props.setDocumentID("");                   // clear document ID field
                        }}
                        required
                    >
                        <option value="">Select Document</option>
                        {props.CKYCData.map(row =>
                            <option key={row.Name} value={row.Name}>{row.Name}</option>
                        )}
                    </select>

                </div>
                <div className="col-md-4">
                    {console.log("Mask:", getDocID, props.DocumentIDValue)}
                    <MaskedInput
                        key={getDocID}
                        mask={
                            getDocID === "PAN"
                                ? [/[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /\d/, /\d/, /\d/, /\d/, /[a-zA-Z]/]
                                : getDocID === "GST"
                                    ? [/\d/, /\d/, /[a-zA-Z]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /[a-zA-Z]/, /[a-zA-Z]/]
                                    : getDocID === "AADHAAR"
                                        ? [/\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/]
                                        : getDocID === "PASSPORT"
                                            ? [/[a-zA-Z]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
                                            : getDocID === "DRIVINGLICENSE"
                                                ? [/[a-zA-Z]/, /[a-zA-Z]/, "-", /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
                                                : getDocID === "VOTERID"
                                                    ? [/[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
                                                    : getDocID === "CIN"
                                                        ? [/[a-zA-Z]/, /[a-zA-Z]/, /\d/, /\d/, /[a-zA-Z]/, /\d/, /\d/, /\d/, /\d/, /[a-zA-Z]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
                                                        : getDocID === "CKYC"
                                                            ? [/[a-zA-Z]/, /[a-zA-Z]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
                                                            : [] // fallback mask to allow typing
                        }

                        guide={false}
                        showMask={false}
                        type="text"
                        name={getDocID}
                        placeholder={props?.DocumentTypeID || "Document ID"}
                        value={props?.DocumentIDValue}
                        onChange={(e) => props.setDocumentID(e.target.value)}
                        disabled={!props.DocumentTypeID}
                        className="packageForm"
                    />


                </div>
                <div className="col-md-4">
                    <div className="UploadDocuments" style={{ display: props.DocumentBase64 === "" ? "" : "none" }}>
                        <input
                            type="file"
                            accept="image/*"
                            className="indemtexted"
                            onChange={async (e) => props.setDocumentBase64(await toBase64(e.target.files[0]))}
                            name="fileUpload"
                            id={props.title === "Identity" ? "POI" : "POA"}
                            hidden
                            required
                        />
                        <label htmlFor={props.title === "Identity" ? "POI" : "POA"} className="POS_File_Upload_Box">
                            <img src={require("../Images/upload.svg").default} />
                            <p>Click to upload file</p>
                        </label>
                    </div>
                    <div style={{ display: props.DocumentBase64 === "" ? "none" : "" }} className="UIM_After02">
                        <button type="button" className="close" onClick={() => props.setDocumentBase64("")}>X</button>
                        <img src={props.DocumentBase64} title={props.title} />
                    </div>
                </div>
            </div>
        </>
    );
};
